import React from "react";
import Title from "../../components/TitleComponent";
import { Row, Col } from "react-bootstrap";
import { Image } from "react-bootstrap";
import Details from "../../components/DetailsComponent";
import Objectives from "../../components/ObjectivesComponent";
import { Helmet } from "react-helmet-async";

export default function AutismDay2026() {
  const toleranceItems = [
    "Sa nu excluzi copilul, dar nici sa nu il implici activ",
    "Sa nu comentezi negativ, dar nici sa nu incerci sa intelegi",
    "Sa accepti prezenta, dar nu si nevoile specifice",
  ];

  const acceptanceItems = [
    "Sa adaptezi mediul, nu copilul",
    "Sa ai rabdare cu modul lui diferit de a comunica",
    "Sa inveti despre nevoile lui, nu sa le ignori",
    "Sa il incluzi in activitati, nu doar sa il lasi 'sa fie acolo'",
    "Sa vezi potentialul, nu doar dificultatile",
  ];

  return (
    <>
      <Helmet>
        <title>Ziua internationala de constientizare a autismului</title>
        <meta
          name="description"
          content="Ziua internationala de constientizare a autismului - eveniment dedicat promovarii acceptarii si incluziunii copiilor cu autism, sensibilizarea societatii asupra nevoilor persoanelor autiste si diseminarea informatiilor corecte despre autism."
        />
        <link rel="canonical" href="https://www.psinapsis.ro/events/autismday2026" />
      </Helmet>

      <Row className="p-0 m-0">
        <Col className="d-none d-xl-block"></Col>
        <Col className="whiteBg p-0 m-0 pb-5 min-xl-screen-size">

          <Title title="Ziua Internationala de Constientizare a Autismului" />

          <Details 
            normalText="𝐓𝐨𝐥𝐞𝐫𝐚𝐧𝐭𝐚 𝐯𝐞𝐫𝐬𝐮𝐬 𝐀𝐜𝐜𝐞𝐩𝐭𝐚𝐫𝐞"
          />

          <Details boldText="Toleranta" normalText=" este o forma minima de convietuire. Ea spune: 'Te las sa existi, chiar daca nu inteleg.' Este o atitudine care evita conflictul, dar nu creeaza apropiere. In contextul autismului, toleranta poate insemna:" />

          <Objectives objectives={toleranceItems} talign="objective-align-left" />

          <Details normalText="Este un pas, dar nu este suficient." />

          <Details boldText="Acceptarea" normalText=" este profunda, activa si empatica. Ea spune: 'Te primesc asa cum esti si iti respect modul unic de a fi.' In autism, acceptarea inseamna:" />

          <Objectives objectives={acceptanceItems} talign="objective-align-left" />

          <Details boldText="Acceptarea creeaza spatiu pentru dezvoltare, relatie si demnitate. Promoveaza apartinerea si starea de bine." />

          <Details normalText="Pentru un copil cu TSA, toleranta poate insemna izolare tacuta, in timp ce acceptarea inseamna conectare reala. Toleranta nu schimba mentalitati, acceptarea da. Toleranta nu construieste incluziune. Acceptarea da." />

          <Details normalText="Copiii cu TSA nu au nevoie doar sa fie tolerati. Au nevoie sa fie acceptati, sprijiniti si inclusi." />

          <div className="mt-4 mb-4">
            <span className="ms-5 me-2">
              <Image src="/icons/calendar_icon.ico" width={20} height={20} />
            </span>
            <span className="fs-6 ms-1 me-5">2 aprilie 2026</span>
          </div>

          <div className="video-container mt-4 mb-4">
            <video 
              width="100%" 
              controls 
              style={{maxWidth: "300px", margin: "0 auto", display: "block"}}
            >
              <source src="/videos/Varianta finala back-up.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </Col>
        <Col className="d-none d-xl-block"></Col>
      </Row>
    </>
  );
}
